import { IHe } from "../../../model/respone/category/IHe";
import { IActionTypeBase } from "../IActionTypeBase";

export enum eHeActionTypeIds {
    LOAD_START = "He_LOAD_START",
    LOAD_SUCCESS = "He_LOAD_SUCCESS",
    LOAD_ERROR = "He_LOAD_ERROR"
}
export interface IHeLoadStart extends IActionTypeBase<eHeActionTypeIds.LOAD_START, undefined> { }
export interface IHeLoadSuccess extends IActionTypeBase<eHeActionTypeIds.LOAD_SUCCESS, IHe[]> { }
export interface IHeLoadError extends IActionTypeBase<eHeActionTypeIds.LOAD_ERROR, string | undefined> { }

export type IHeActionTypes = IHeLoadStart | IHeLoadSuccess | IHeLoadError